import { roundNumber } from '@/lib/formatUtils';

interface TotalValues {
  tongSoLuong: number;
  tongTienNt: number;
  tongTienNt2: number;
  tongChietKhau: number;
  tongThue: number;
  tongThanhToan: number;
}

export function calculateTotals(detailItems: BanHangRecord[] = []): TotalValues {
  // Calculate totals from detail items
  const tongSoLuong = detailItems.reduce((sum, item) => sum + Number(item.so_luong || 0), 0);
  const tongTienNt = detailItems.reduce((sum, item) => sum + Number(item.tien_nt || 0), 0);
  const tongTienNt2 = detailItems.reduce((sum, item) => sum + Number(item.tien_nt2 || 0), 0);
  const tongChietKhau = detailItems.reduce((sum, item) => sum + Number(item.ck_nt || 0), 0);
  // Calculate total tax from tax details
  const tongThue = detailItems.reduce((sum, item) => sum + Number(item.thue_nt || 0), 0);
  const tongThanhToan = tongTienNt2 + tongThue;
  return {
    tongSoLuong: roundNumber(tongSoLuong),
    tongTienNt: roundNumber(tongTienNt),
    tongTienNt2: roundNumber(tongTienNt2),
    tongChietKhau: roundNumber(tongChietKhau),
    tongThue: roundNumber(tongThue),
    tongThanhToan: roundNumber(tongThanhToan)
  };
}

export const handleUpdateRowFields = (row: BanHangRecord, field: string, newValue: BanHangValue) => {
  if (
    field === 'so_luong' ||
    field === 'gia_nt2' ||
    field === 'tl_ck' ||
    field === 'ma_thue_data' ||
    field === 'gia_nt'
  ) {
    const so_luong = field === 'so_luong' ? newValue : row.so_luong;
    const gia_nt = field === 'gia_nt' ? newValue : row.gia_nt;
    const gia_nt2 = field === 'gia_nt2' ? newValue : row.gia_nt2;
    const tl_ck = field === 'tl_ck' ? newValue : row.tl_ck;
    const thue_suat = field === 'ma_thue_data' ? newValue?.thue_suat || 0 : row.ma_thue_data?.thue_suat || 0;

    const tien_nt2 = (Number(so_luong) || 0) * (Number(gia_nt2) || 0);
    const tien_nt = (Number(so_luong) || 0) * (Number(gia_nt) || 0);
    const ck_nt = (tien_nt2 * (Number(tl_ck) || 0)) / 100;
    const thue_nt = (tien_nt2 * (Number(thue_suat) || 0)) / 100;

    return {
      tien_nt2: roundNumber(tien_nt2),
      ck_nt: roundNumber(ck_nt),
      thue_nt: roundNumber(thue_nt),
      tien_nt: roundNumber(tien_nt)
    };
  }
  if (field === 'ma_vt_data') {
    return {
      dvt: newValue?.dvt_nl_data?.uuid || newValue?.dvt_data?.uuid || row.dvt,
      ma_kho_data: newValue?.ma_kho_data || row.ma_kho_data,
      tk_tl_data: newValue?.tk_tl_data || row.tk_tl_data,
      tk_dt_data: newValue?.tk_dt_data || row.tk_dt_data,
      tk_gv_data: newValue?.tk_gv_data || row.tk_gv_data,
      tk_km_data: newValue?.tk_km_data || row.tk_km_data,
      tk_ck_data: newValue?.tk_ck_data || row.tk_ck_data,
      tk_khcp_data: newValue?.tk_khcp_data || row.tk_khcp_data
    };
  }
  return {};
};
